class ProductCardSwatches {
  constructor() {
    this.init();
  }

  init() {
    this.setDefaultActiveSwatches();
    this.bindEvents();
  }

  setDefaultActiveSwatches() {
    // Find all variant selectors and set the first swatch as active
    const variantSelectors = document.querySelectorAll('[data-product-id]');
    // console.log("variantSelectors: ", variantSelectors);
    variantSelectors.forEach(selector => {
      const firstSwatch = selector.querySelector('[data-option]');
      // console.log("firstSwatch: ", firstSwatch);
      if (firstSwatch && !selector.querySelector('[data-option].active')) {
        // console.log("firstSwatch is active");
        firstSwatch.classList.add('active');
      }
    });
  }

  bindEvents() {
    // Add onclick handlers to all swatch elements
    this.addSwatchClickHandlers();

    // Add onclick handlers to "more" buttons
    this.addMoreButtonHandlers();

    // Listen for quantity button clicks
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('quantity-button')) {
        this.handleQuantityButtonClick(event.target);
      }
    });

    // Listen for add to cart button clicks
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('add-to-cart-button')) {
        this.handleAddToCartClick(event.target);
      }
    });

    // Listen for custom quick add button clicks
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('custom-quick-add-button')) {
        this.handleCustomQuickAddClick(event.target);
      }
    });
  }

  addSwatchClickHandlers() {
    // Find all swatch elements and add onclick handlers
    const swatchElements = document.querySelectorAll('[data-option]');
    swatchElements.forEach(swatch => {
      swatch.onclick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        // console.log("swatch clicked via onclick: ", swatch);
        this.handleSwatchClick(swatch);
      };
    });
  }

  addMoreButtonHandlers() {
    // Find all "more" buttons and add onclick handlers
    const moreButtons = document.querySelectorAll('[data-more-variants]');
    moreButtons.forEach(button => {
      button.onclick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        // console.log("more button clicked: ", button);
        this.handleMoreButtonClick(button);
      };
    });
  }

  handleSwatchClick(swatchElement) {
    const variantSelector = swatchElement.closest('[data-product-id]');
    // console.log("variantSelector: ", variantSelector);
    
    if (!variantSelector) {
      console.warn('Variant selector not found');
      return;
    }

    const productId = variantSelector.dataset.productId;
    const imgSrc = swatchElement.dataset.imgSrc;
    const value = swatchElement.dataset.value;

    // console.log('Swatch clicked:', { productId, imgSrc, value });

    if (!imgSrc) {
      console.warn('No image source found for swatch');
      return;
    }

    // Find the product card
    const productCard = variantSelector.closest('.card-wrapper');
    if (!productCard) {
      console.warn('Product card not found');
      return;
    }

    // Find the primary image
    const primaryImage = productCard.querySelector('.primary_image');
    if (!primaryImage) {
      console.warn('Primary image not found');
      return;
    }

    // Update the image
    this.updateProductImage(primaryImage, imgSrc, value);

    // Update active state of swatches
    this.updateSwatchActiveState(swatchElement);
  }

  updateProductImage(imageElement, imageUrl, variantValue) {
    // Add a fade-out effect
    imageElement.style.opacity = '0.5';
    imageElement.style.transition = 'opacity 0.3s ease';

    // Update image src
    imageElement.src = imageUrl;

    // Generate srcset for responsive images
    // We'll create different sizes based on the original image URL
    const baseUrl = imageUrl.split('?')[0]; // Remove query parameters
    const srcset = `
      ${baseUrl}?width=165 165w,
      ${baseUrl}?width=360 360w,
      ${baseUrl}?width=533 533w,
      ${baseUrl}?width=720 720w,
      ${baseUrl}?width=940 940w,
      ${baseUrl}?width=1066 1066w
    `;
    imageElement.srcset = srcset;

    // Update alt text to include variant info
    const originalAlt = imageElement.alt;
    const baseAlt = originalAlt.replace(/\s*-\s*[^-]+$/, ''); // Remove any existing variant info
    imageElement.alt = `${baseAlt} - ${variantValue}`;

    // Fade back in
    setTimeout(() => {
      imageElement.style.opacity = '1';
    }, 150);
  }

  updateSwatchActiveState(clickedSwatch) {
    // Remove active class from all swatches in the same variant selector
    const variantSelector = clickedSwatch.closest('[data-product-id]');
    if (variantSelector) {
      const allSwatches = variantSelector.querySelectorAll('[data-option]');
      allSwatches.forEach(swatch => {
        swatch.classList.remove('active');
      });
    }

    // Add active class to clicked swatch
    clickedSwatch.classList.add('active');
  }

  handleQuantityButtonClick(button) {
    const container = button.closest('.quantity-selector');
    if (!container) return;

    const input = container.querySelector('.quantity-input');
    if (!input) return;

    const currentValue = parseInt(input.value) || 1;
    const min = parseInt(input.min) || 1;

    if (button.classList.contains('minus')) {
      input.value = Math.max(min, currentValue - 1);
    } else if (button.classList.contains('plus')) {
      input.value = currentValue + 1;
    }

    // Trigger change event
    input.dispatchEvent(new Event('change'));
  }

  handleAddToCartClick(button) {
    const variantSelector = button.closest('[data-product-id]');
    if (!variantSelector) return;

    const productId = variantSelector.dataset.productId;
    const quantityInput = variantSelector.querySelector('.quantity-input');
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

    // Get selected variant
    const activeSwatch = variantSelector.querySelector('[data-option].active');
    const selectedValue = activeSwatch ? activeSwatch.dataset.value : null;

    // console.log('Add to cart:', {
    //   productId: productId,
    //   quantity: quantity,
    //   selectedVariant: selectedValue
    // });

    // Here you can implement the actual add to cart functionality
    // For now, we'll just show a console message
    // alert(`Added ${quantity} item(s) to cart for variant: ${selectedValue || 'default'}`);
  }

  handleMoreButtonClick(button) {
    const wrapper = button.closest('[data-option-wrapper]');
    if (!wrapper) {
      console.warn('Option wrapper not found');
      return;
    }

    const hiddenVariants = wrapper.querySelectorAll('.hidden-variant');
    const isExpanded = button.classList.contains('expanded');

    if (isExpanded) {
      // Collapse - hide variants and update button
      hiddenVariants.forEach(variant => {
        variant.classList.remove('show');
      });
      button.classList.remove('expanded');
      
      // Update button text to show count
      const count = hiddenVariants.length;
      button.querySelector('.more-count').textContent = `+${count}`;
    } else {
      // Expand - show variants and update button
      hiddenVariants.forEach(variant => {
        variant.classList.add('show');
      });
      button.classList.add('expanded');
      
      // Update button text to show collapse indicator
      button.querySelector('.more-count').textContent = '−';
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new ProductCardSwatches();
});

// Also initialize for dynamic content (if using AJAX or similar)
if (typeof window !== 'undefined') {
  window.ProductCardSwatches = ProductCardSwatches;
} 